import { browser } from "$app/environment";
import { communitySlug } from "$stores/community";
import { get } from "svelte/store";

export function track(event: string) {
  if (browser) {
    window.posthog?.capture(event, { groupId: get(communitySlug) });
  }
}

export function trackNotAuthed(event: string, email: string, content: string) {
  if (browser) {
    window.posthog?.capture(event, { email, content });
  }
}

export function toPercent(rate: number): string {
  if (!Number.isFinite(rate)) {
    return "N/A";
  }
  return `${Math.round(rate * 100 * 10) / 10}%`;
}
